import React, { FC, useRef, MouseEvent } from 'react';
import Svg from 'svg-inline-react';
import FrCheckSvg from '@src/svgs/fr-check.svg';
import FrChatSvg from '@src/svgs/fr-chat-small.svg';
import { ConnectProps } from './props';
import './styles.scss';

export const Connect: FC<ConnectProps> = ({ userId, hasConnected, onConfirmTalent, isDirectConnect }) => {
  const acceptButtonRef = useRef<HTMLDivElement | null>(null);

  const onConfirmClick = (event: MouseEvent<HTMLDivElement>): void => {
    event.stopPropagation();

    if (isDirectConnect) {
      onConfirmTalent({ userId });
    }
  };

  if (hasConnected) {
    return (
      <div className="featured-applicant-connect featured-applicant-connect--invite-sent fade-in">
        <Svg className="featured-applicant-connect__invite-sent-icon" src={FrCheckSvg} />
        Invite sent
      </div>
    );
  }

  return (
    <div className="featured-applicant-connect" onClick={onConfirmClick} ref={acceptButtonRef}>
      <Svg className="featured-applicant-connect__action-icon" src={FrChatSvg} />
      Contact me
    </div>
  );
};
